import { Modal, ModalProps } from 'react-bootstrap';

interface ReadMoreModalI {
  closeModal: () => void;
  headerText?: string;
  data: JSX.Element | string;
  className?: string;
  modalHeaderClassName?: string;
  modalBodyClassName?: string;
  dataBodyClassName?: string;
  modalContentClassName?: string;
  size?: ModalProps['size'];
}

export const ReadMoreModal = ({
  className = 'h-80',
  ...props
}: ReadMoreModalI) => {
  return (
    <Modal
      show={true}
      onHide={props.closeModal}
      size={props.size}
      scrollable
      className={className}
      contentClassName={props.modalContentClassName}
    >
      <Modal.Header closeButton className={props.modalHeaderClassName}>
        <div>
          <h4 className="font-semibold  text-body-emphasis">
            {props.headerText}
          </h4>
        </div>
      </Modal.Header>
      <Modal.Body className={props.modalBodyClassName}>
        <div className={`row px-3 py-2 ${props.dataBodyClassName}`}>
          {props.data}
        </div>
      </Modal.Body>
    </Modal>
  );
};
